<template>
    <div class="m-t-20">
       <div class="columns m-t-20">
            <div class="column is-flex">
                <h2 class="has-text-weight-medium is-size-4">Variantes. </h2>
                <b-switch 
                v-model="micro" 
                v-on:input="updateData({obj:'micromanage', data:micro})" 
                class="m-l-20" 
                type="is-success">
                    Micro-administrar variantes
                </b-switch>
            </div>
        </div>
        <div v-if="getMicromanage">
            <VariantFormElement 
            v-for="(x, i) in getVariants" 
            :key="i" 
            :data="x" 
            :index="i"
            @deleteVar="deleteVariant(i)"/>

            <b-button :disabled="!getAttributes.length > 0" @click="addVariant" type="is-light m-r-20" rounded> 
                <b-icon icon="plus" size="is-small"></b-icon>
                <span v-if="!getAttributes.length > 0">Agrega un atributo primero</span>
                <span v-else> Aggregar variante</span>
            </b-button>
        </div>
        

    </div>    
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import VariantFormElement from "./VariantFormElement"

export default {
    data(){
        return{
            micro:false
        }
    },
    components:{
        VariantFormElement
    },
    computed:{
        ...mapGetters(['getMicromanage', 'getVariants', 'getAttributes'])
    },
    methods:{
        ...mapActions(["updateData", "addVariant", "deleteVariant"])
    }
    
}
</script>

